import { z } from 'zod';

export const LookupVehicleByPlateQuerySchema = z.object({
  plate: z.string().trim().min(1),
});

export type LookupVehicleByPlateParams = z.infer<typeof LookupVehicleByPlateQuerySchema>;

export const VehiclePlateLookupResponseSchema = z.object({
  plateNormalized: z.string(),
  brandName: z.string(),
  modelName: z.string(),
  brandId: z.uuid().nullable(),
  vehicleModelId: z.uuid().nullable(),
  modelYear: z.number().nullable(),
  manufactureYear: z.number().nullable(),
  color: z.string().nullable(),
  fuelType: z.string().nullable(),
  vehicleGenerationId: z.uuid().nullable(),
  vehicleTrimId: z.uuid().nullable(),
  vehicleEngineId: z.uuid().nullable(),
  fipeCode: z.string().nullable(),
  chassis: z.string().nullable(),
  chassisMasked: z.string().nullable(),
  engineNumber: z.string().nullable(),
  nickname: z.string().nullable(),
  source: z.string(),
  fetchedAt: z.iso.datetime(),
});

export type VehiclePlateLookupResponse = z.infer<typeof VehiclePlateLookupResponseSchema>;
